import { FunctionComponent } from "react";
import Link from "rivals/components/shared/Link";
import { PATHS } from "rivals/shared/constants";
import { setData } from "rivals/shared/utils/qa";
import styles from "./SubscriptionTerms.module.scss";
import strings from "./strings";

export const FreeTerms: FunctionComponent = () => {
  return (
    <div className={styles.terms} {...setData("create-account", "tos")}>
      {strings.iAgree}
      <Link href={PATHS.YAHOO_TERMS} target="_blank">
        {strings.yahooTerms}
      </Link>
      {", "}
      <Link href={PATHS.RIVALS_TERMS} target="_blank">
        {strings.additionalRivalsTerms}
      </Link>
      {", and "}
      <Link href={PATHS.YAHOO_PRIVACY} target="_blank">
        {strings.yahooPolicy}
      </Link>
    </div>
  );
};

const SubscriptionTerms: FunctionComponent = () => {
  return (
    <div className={styles.terms} {...setData("subscription", "tos")}>
      <p>
        {strings.iAgree}
        <Link href={PATHS.YAHOO_TERMS} target="_blank">
          {strings.yahooTerms}
        </Link>
        {", "}
        <Link href={PATHS.RIVALS_TERMS} target="_blank">
          {strings.rivalsTerms}
        </Link>
        {", and "}
        <Link href={PATHS.YAHOO_PRIVACY} target="_blank">
          {strings.yahooPolicy}
        </Link>
        {strings.followingTerms}
      </p>
      <p>
        {strings.paidTerms1}{" "}
        <Link href={PATHS.SUBSCRIPTIONS}>{strings.subPage}</Link>{" "}
        {strings.paidTerms2}{" "}
        <Link href={PATHS.SUBSCRIPTIONS}>{strings.subPage}</Link>{" "}
        {strings.paidTerms3}
      </p>
      <p>
        {strings.paidTerms4} <Link href={PATHS.GUCE}>{strings.doNotSell}</Link>
      </p>
    </div>
  );
};

export default SubscriptionTerms;
